export enum DeviceModelType {
  OG = 'OG',
  LIGHTNING = 'Lightning',
}

export enum DeviceModelVariant {
  OG = 0,
  LIGHTNING = 1,
}
